import { FC } from "react";
import { IonSkeletonText } from "@ionic/react";
import { AllieSkeletonProps } from "./Skeleton.types";

export const AllieSkeleton: FC<AllieSkeletonProps> = (props) => (
  <IonSkeletonText {...props} />
);
